import { render, staticRenderFns } from "./LocaleStringForm.vue?vue&type=template&id=de5476d8&scoped=true&"
import script from "./LocaleStringForm.vue?vue&type=script&lang=js&"
export * from "./LocaleStringForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de5476d8",
  null
  
)

export default component.exports